'use strict';

angular.module('ticketAssignment')
    .controller('TicketAuditCtrl', [
        '$scope', 'ticketAuditViewModel', '$state', '$stateParams',
        function ($scope, viewModel, $state, $stateParams) {
            $scope.model = new viewModel($stateParams.id);
        }
    ]);